"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("./component");
var geometry_1 = require("./geometry");
var global_1 = require("./global");
var LinearLayout = /** @class */ (function (_super) {
    __extends(LinearLayout, _super);
    function LinearLayout() {
        var _this = _super.call(this) || this;
        _this.isLayout = true;
        _this.gap = 0;
        _this.elements = [];
        return _this;
    }
    LinearLayout.prototype.defaultOptions = function () {
        return { _direction: "vertical" };
    };
    LinearLayout.prototype.render = function () {
        _super.prototype.render.call(this);
        var isHorizontal = this.getOption("_direction") === "horizontal";
        if (isHorizontal) {
            var x = 0;
            for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
                var child = _a[_i];
                child.dom.attr("y", 0)
                    .attr("x", x);
                var width = child.getSize(true);
                if (typeof width === "number" && width > 0) {
                    x += width;
                }
                else {
                    var bbox = child.dom.node().getBBox();
                    x += bbox.x + bbox.width;
                }
            }
        }
        else {
            var y = 0;
            for (var _b = 0, _c = this.elements; _b < _c.length; _b++) {
                var child = _c[_b];
                child.dom.attr("x", 0)
                    .attr("y", y)
                    .attr("width", global_1.default.currentVisualizer.size.width);
                var height = child.getSize(false);
                if (typeof height === "number" && height > 0) {
                    y += height;
                }
                else {
                    var bbox = child.dom.node().getBBox();
                    y += bbox.y + bbox.height;
                }
            }
        }
    };
    LinearLayout.prototype.renderElement = function () {
        return;
    };
    LinearLayout.nodeName = "g";
    return LinearLayout;
}(component_1.Component));
exports.LinearLayout = LinearLayout;
var LayoutItem = /** @class */ (function (_super) {
    __extends(LayoutItem, _super);
    function LayoutItem() {
        var _this = _super.call(this) || this;
        _this._options._height = { value: 100, unit: geometry_1.GeometryUnit.Percent, offset: 0 };
        _this._options._width = { value: 100, unit: geometry_1.GeometryUnit.Percent, offset: 0 };
        return _this;
    }
    LayoutItem.parseAttributeValue = function (attr, value) {
        switch (attr) {
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    LayoutItem.prototype.getSize = function (horizontal) {
        return this._getGeometry(horizontal ? "_width" : "_height", horizontal);
    };
    LayoutItem.nodeName = "svg";
    return LayoutItem;
}(component_1.Component));
exports.LayoutItem = LayoutItem;
//# sourceMappingURL=layout.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/layout.js
// module id = 1190
// module chunks = 0 1